import { SWRFetcher } from '@commenda/utils';
import { MarketplaceServiceType } from '@prisma/client';
import useSWR, { KeyedMutator } from 'swr';
import { TVendorService } from './types';

interface MarketplaceServiceRequestProps {
  caFirmId?: string;
  categories?: MarketplaceServiceType[];
  includeProductInfo?: boolean;
  includeCaCaFirmInfo?: boolean;
  includeVendorPricingVariants?: boolean;
}

export function useMarketplaceServicesByVendor({
  caFirmId,
  categories,
  includeProductInfo,
  includeCaCaFirmInfo,
  includeVendorPricingVariants,
}: MarketplaceServiceRequestProps = {}): {
  data?: TVendorService[];
  error?: unknown;
  mutate: KeyedMutator<TVendorService[]>;
} {
  const queryParams = new URLSearchParams();
  if (caFirmId) queryParams.set('caFirmId', caFirmId);
  if (categories) queryParams.set('categories', categories.join(','));
  if (includeProductInfo) queryParams.set('includeProductInfo', 'true');
  if (includeCaCaFirmInfo) queryParams.set('includeCaCaFirmInfo', 'true');
  if (includeVendorPricingVariants)
    queryParams.set('includeVendorPricingVariants', 'true');

  const { data, error, mutate } = useSWR<TVendorService[]>(
    `marketplace/vendors/services?${queryParams.toString()}`,
    SWRFetcher({
      method: 'GET',
    })
  );

  return { data, error, mutate };
}
